import React from 'react';
import { useRecoilValue } from 'recoil';
import { BundleConfigWithAssets } from '../hooks/useBundleConfig';
import { ShopifyCurrency } from '../models/ShopifyCurrency.model';
import { allProductsState, shopifyState } from '../recoil/atoms';
import { cleanPrice, currencyToString } from '../util';

interface BundleProductPriceProps {
  style?: React.CSSProperties;
  bundleCollectionConfig: BundleConfigWithAssets;
}

export const BundleProductPrice: React.FC<BundleProductPriceProps> = ({ style, bundleCollectionConfig }) => {
  const shopify = useRecoilValue(shopifyState);
  const allProducts = useRecoilValue(allProductsState);
  const currency: ShopifyCurrency = shopify?.currency ?? { active: 'USD', rate: 1 };

  const priceData = bundleCollectionConfig.productColorCombos[0].colorCombos.reduce(
    (acc, curr) => {
      const originalPrice = allProducts[curr.productHandle].price * curr.quantity;
      const discountPrice = Math.round(originalPrice * ((100 - bundleCollectionConfig.percentageDiscount) / 100));

      return { originalPrice: acc.originalPrice + originalPrice, discountPrice: acc.discountPrice + discountPrice };
    },
    { originalPrice: 0, discountPrice: 0 },
  );

  const originalDisplayPice = cleanPrice(currencyToString({ active: currency.active } as ShopifyCurrency, priceData.originalPrice));
  const discountDisplayPice = cleanPrice(currencyToString({ active: currency.active } as ShopifyCurrency, priceData.discountPrice));

  return (
    <div style={style}>
      <span style={{ textDecoration: 'line-through', marginRight: '6px', color: '#666' }}>{originalDisplayPice}</span>
      {discountDisplayPice}
    </div>
  );
};

export default BundleProductPrice;
